import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dataRectify',
  templateUrl: './dataRectify.component.html',
   
})
export class dataRectifyComponent implements OnInit {   
  constructor() { }
  ngOnInit() {     
    }

}



// WEBPACK FOOTER //
// ./src/app/dataRectify/dataRectify.component.ts